"use client"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronRight } from "@fortawesome/free-solid-svg-icons"
import type { FC } from "react"
import { useTranslation } from "react-i18next"
import CountryFlag from "@/components/common/CountryFlag"
import { useTERouter } from "@/hooks/app/useTERouter"
import { useTETranslation } from "@/hooks/app/useTETranslation"
import { getVisaPopularCountries, type VisaCountryEntry } from "@/utils/country/getVisaCountries"

type VisaPopularCountriesProps = {
  /** Mở dropdown chọn điểm đến đầy đủ (browse theo châu lục) thay vì điều hướng ngay. */
  onViewAll: () => void
}

/**
 * Hàng "Quốc gia phổ biến" dưới ô search (theo mockup) — bấm 1 quốc gia là điều hướng thẳng
 * sang trang kết quả đã lọc sẵn theo quốc gia đó, không cần bấm thêm nút "Tìm visa". Danh sách
 * lấy từ public/static/data/visa-countries.json (mục "popular"), sếp chỉnh sửa file này là đủ,
 * không cần sửa code.
 */
const VisaPopularCountries: FC<VisaPopularCountriesProps> = ({ onViewAll }) => {
  const { t } = useTranslation()
  const { getTranslatedText } = useTETranslation()
  const router = useTERouter()
  const countries = getVisaPopularCountries()

  const goToCountry = (country: VisaCountryEntry) => {
    const params = new URLSearchParams()
    params.set("keyword", getTranslatedText(country.name, country.nameEn))
    params.set("destinationCountryCode", country.code)
    router.push(`/dich-vu-visa/ket-qua-tim-kiem?${params.toString()}`)
  }

  return (
    <div className="visa-popular-countries">
      <span className="visa-popular-countries__label">{t("visa.form_search.popular_countries_label")}</span>

      <div className="visa-popular-countries__list">
        {countries.map((country) => (
          <button
            type="button"
            key={country.code}
            className="visa-popular-countries__item"
            onClick={() => goToCountry(country)}
          >
            <CountryFlag code={country.code.toLowerCase()} size={16} />
            <span>{getTranslatedText(country.name, country.nameEn)}</span>
          </button>
        ))}
      </div>

      <button type="button" className="visa-popular-countries__view-all" onClick={onViewAll}>
        {t("visa.form_search.popular_countries_view_all")}
        <FontAwesomeIcon icon={faChevronRight} />
      </button>
    </div>
  )
}

export default VisaPopularCountries
